import { Component } from '@angular/core';
import { Message } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Store } from '@ngrx/store';

import { DadosPastasFormComponent } from '../dados-pastas-form/dados-pastas-form.component';
import { IFolder } from 'src/app/shared/interfaces/folder/ifolder';
import { deleteFolder, loadFolder } from 'src/app/store/folder/folder.actions';
import { selectFolderLista } from 'src/app/store/folder/folder.selectors';

@Component({
  selector: 'app-dados-pastas',
  templateUrl: './dados-pastas.component.html',
  styleUrls: ['./dados-pastas.component.scss'],
})
export class DadosPastasComponent {
  mostrarModalExcluir: boolean = false;
  mostrarModalInativar: boolean = false;

  ref: DynamicDialogRef | undefined;

  messages: Message[] = [
    {
      severity: 'warn',
      summary: '',
      detail:
        'Preencha essas informações pela primeira vez e salve as suas preferências. ',
    },
  ];

  constructor(
    public dialogService: DialogService,
    private store: Store<IFolder>
  ) {}

  ngOnInit(): void {
    this.store.dispatch(loadFolder());
  }

  lista$ = this.store.select(selectFolderLista);

  public showForm() {
    this.ref = this.dialogService.open(DadosPastasFormComponent, {
      header: 'Adicionar documentos',
      dismissableMask: true,
      width: '45%',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
    });
  }

  iterateEmployees(titles: any) {
    const employeeNames = titles.map((employee: any) => employee.name);

    return employeeNames;
  }

  editItem(item: IFolder) {
    this.ref = this.dialogService.open(DadosPastasFormComponent, {
      header: 'Pastas',
      width: '50%',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
      dismissableMask: true,
      data: {
        item: item,
      },
    });
  }
  deleteItem(id: number) {
    this.store.dispatch(deleteFolder({ id: id }));
  }
}
